import React from 'react';
import { observer } from 'mobx-react';
import { reaction } from 'mobx';
import { Spring, animated } from 'react-spring';

import { navigate, url } from 'js/services/Network';
import analytics from 'js/services/Analytics';
import AppUser from 'js/stores/AppUser';
import { lightGrey1Color } from 'js/config/style';

import AppContent from 'js/components/AppContent';
import PageComponent from 'js/components/pages/PageComponent';
import Backdrop from 'js/components/core/Backdrop';
import Constraint from 'js/components/Constraint';

import Message from './Message';
import Button from './Button';
import Center from './Center';
import PageTitle from './PageTitle';

@observer
export default class LogoutPage extends PageComponent {
  pageName = 'LogoutPage';
  pageColor = lightGrey1Color;
  loginRequired = true;

  pageEvent = () => analytics.page('Logout');

  constructor(props) {
    super(props);
    this.loggedInReaction = reaction(() => AppUser.isLoggedIn, isLoggedIn => isLoggedIn && navigate(url('home-page')));
  }

  componentWillUnmount() {
    this.loggedInReaction();
  }

  renderPage() {
    const isLoggingOut = AppUser.isLoggingOut;
    return (
      <AppContent padded>
        <Backdrop>
          <Constraint>
            <PageTitle>Logout</PageTitle>
            <Message>
              <p>We are sorry to see you leave, come back soon!</p>
              <p>You can use the button below to logout.</p>
            </Message>
          </Constraint>
        </Backdrop>

        <Constraint>
          <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
            {animation => (
              <animated.div style={animation}>
                <Center>
                  <Button onClick={AppUser.logoutUser} isLoading={isLoggingOut}>
                    {isLoggingOut ? 'Logging out' : 'Logout now'}
                  </Button>
                </Center>
              </animated.div>
            )}
          </Spring>
        </Constraint>
      </AppContent>
    );
  }
}
